export default (facility) => {
  let className;

  if (facility.isFilter) {
    // className = 'disabledDefault'; // 회색
    if (facility.isDefault) {
      className = 'disabledDefault'; // 회색
    } else {
      className = 'disabledAdd'; // 회색
    }
  } else if (facility.selected) {
    if (facility.isDefault) {
      className = 'default'; // 회색
    } else if (!facility.isDefault) {
      className = 'addException'; // 회색
    }
  } else if (facility.isDefault) {
    className = 'removeException'; // 회색
  }
  // if (facility.isChange === true) {
  //   if (facility.isException) {
  //     if (facility.selected) {
  //       className = 'addException'; // 빨강
  //     } else {
  //       className = 'removeException'; // 주황
  //     }
  //   } else if (facility.isDefault) {
  //     className = 'default'; // 파랑
  //   } else {
  //     className = 'normal'; // 검정
  //   }
  // } else if (facility.isException) {
  //   if (facility.selected) {
  //     className = 'addException'; // 빨강
  //   } else {
  //     className = 'removeException'; // 주황
  //   }
  // } else if (facility.isDefault) {
  //   className = 'default'; // 파랑
  // } else {
  //   className = 'normal'; // 검정
  // }
  return className;
};


//



// WEBPACK FOOTER //
// ./src/filters/getClassNameByException.js